import * as React from 'react';
import { SignalSource } from '../data/SignalSource';
import { getStoreState } from '../state/Store';
import { MotionSignalSelectBackground } from './MotionSignalSelectBackground';
import { Popover } from 'react-tiny-popover';

const SignalsLabels = {
  [SignalSource.Default]: 'Main',
  [SignalSource.Full]: 'Always Full',
  [SignalSource.Playback]: 'Playback position',
  [SignalSource.PlaybackLoop]: 'Loop once',
  [SignalSource.Seconds15Loop]: 'Loop every 15 secs',
  [SignalSource.RandomOne]: 'Random 1',
  [SignalSource.RandomTwo]: 'Random 2',
  [SignalSource.GlitchOne]: 'Glitch 1',
  [SignalSource.GlitchTwo]: 'Glitch 2',
  [SignalSource.BeatSmooth]: 'Beat smooth',
  [SignalSource.BeatNormal]: 'Beat normal',
  [SignalSource.BeatSharp]: 'Beat sharp',
  [SignalSource.FrequencesLow]: 'Low frequencies',
  [SignalSource.FrequencesMidLow]: 'Mid-low frequencies',
  [SignalSource.FrequencesMidHigh]: 'Mid-high frequencies',
  [SignalSource.FrequencesHigh]: 'High frequencies'
};

interface Props {
  value: SignalSource;
  inverted: boolean;
  onChange: (value: SignalSource) => void;
}

class MotionSignalSelect extends React.Component<Props> {
  state = {
    isOpen: false
  };
  onClick = (key: string) => {
    if (key !== this.props.value) {
      this.props.onChange(key as SignalSource);
    }
  };
  render() {
    let signalOptions = [
      SignalSource.Default,
      SignalSource.Full,
      SignalSource.Playback,
      SignalSource.PlaybackLoop,
      SignalSource.Seconds15Loop
    ];
    if (getStoreState().flyer.soundtrack) {
      signalOptions = signalOptions.concat([
        SignalSource.BeatSmooth,
        SignalSource.BeatNormal,
        SignalSource.BeatSharp,
        SignalSource.FrequencesLow,
        SignalSource.FrequencesMidLow,
        SignalSource.FrequencesMidHigh,
        SignalSource.FrequencesHigh
      ]);
    }
    signalOptions = signalOptions.concat([
      SignalSource.GlitchOne,
      SignalSource.GlitchTwo,
      SignalSource.RandomOne,
      SignalSource.RandomTwo
    ]);

    return (
      <Popover
        isOpen={this.state.isOpen}
        positions={['bottom', 'top', 'right', 'left']} // preferred positions by priority
        onClickOutside={() => this.setState({ isOpen: false })}
        align="center"
        reposition={true}
        content={
          <div className="animation-options">
            {signalOptions.map((item, index) => (
              <div
                key={index}
                className={`bf-select motion-select animation-options-item ${
                  item === this.props.value
                    ? 'animation-options-item--selected'
                    : ''
                }`}
                onClick={() => this.onClick(item)}
              >
                <MotionSignalSelectBackground
                  signal={item}
                  selected={item === this.props.value}
                />
                <span>{SignalsLabels[item]}</span>
              </div>
            ))}
          </div>
        }
      >
        <div
          className={
            'bf-select' +
            (this.state.isOpen ? ' bf-select--open' : '') +
            ' motion-select'
          }
          onClick={() => this.setState({ isOpen: !this.state.isOpen })}
        >
          <MotionSignalSelectBackground
            signal={this.props.value}
            inverted={this.props.inverted}
            selected={true}
          />
          <span>{SignalsLabels[this.props.value]}</span>
          <svg
            width="26px"
            height="20px"
            viewBox="0 0 26 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <g stroke="none" fill="none">
              <g fill="currentColor">
                <polygon points="18.0710678 8 13.0355339 13.0355339 8 8" />
              </g>
            </g>
          </svg>
        </div>
      </Popover>
    );
  }
}

export { MotionSignalSelect };



// WEBPACK FOOTER //
// ./src/components/MotionSignalSelect.tsx